export default __webpack_public_path__ + "static/1544-e81eb45aa370f52976d0c1f60d3308e5.gif";